export enum ONLINE_COURSE_PAYMENT {
    PENDING = 'PENDING', //รอยืนยันการชำระเงิน
    CONFIRMED = 'CONFIRMED', //ยืนยันการชำระเงินแล้ว
    REJECT = 'REJECT'
}

export const renderStatus = (status: string): string => {
    if (status === ONLINE_COURSE_PAYMENT.CONFIRMED) {
        return "ยืนยันการชำระเงินแล้ว"
    }
    else if (status === ONLINE_COURSE_PAYMENT.PENDING) {
        return "รอยืนยันการชำระเงิน"
    }
    else if (status === ONLINE_COURSE_PAYMENT.REJECT) {
        return "ไม่อนุมัติ"
    }
    return ""
}